<template>
  <div v-if="vueModel.showTopbanner">
    <div v-cloak id="topBannerPowerOfAttorney" class="top-banner-power-of-attorney">
      <div class="container row collapse">
        <div class="medium-8 columns show-for-medium">
          <div class="row">
            <div class="medium-4 large-2 columns" v-html="vueModel.powerOfAttorneyFromLabel" />
            <div class="medium-8 large-10 columns" v-html="vueModel.powerOfAttorneyGiverName" />
          </div>
          <div class="row">
            <div class="medium-4 large-2 columns" v-html="vueModel.accessToLabel" />
            <div class="medium-8 large-10 columns" v-html="vueModel.rightText" />
          </div>
        </div>
        <div class="medium-4 columns">
          <div class="row">
            <div v-if="vueModel.isPowerOfAttorneyContactCurrentlyInOwnBrand" class="columns">
              <button
                class="button secondary align-center"
                @click="switchBackFromPOA"
                v-html="vueModel.switchToSelfButtonText"
              />
            </div>

            <div
              v-if="
                vueModel.hasMoreThanOnePoaInCurrentBrand &&
                  !vueModel.isPowerOfAttorneyContactCurrentlyInOwnBrand
              "
              class="columns"
            >
              <button
                class="button secondary align-center"
                @click="switchBackToList(vueModel.linkPowerOfAttorneyPage)"
                v-html="vueModel.goToPowerOfAttorneyOverviewButtonText"
              />
            </div>
          </div>
        </div>
      </div>

      <transition v-cloak name="modal">
        <v-modal :is-open="showModalFail" @close="showModalFail = false">
          <template #title>
            <h3>Uventet fejl</h3>
          </template>
          <template #content>
            <div>
              <p>
                Der skete en uventet fejl. Prøv igen senere eller kontakt os.
                <a class="text-large" href="tel:+4533117755">Ring 33 11 77 55</a>
              </p>
              <a class="button large close-modal" @click="showModalFail = false">Luk</a>
            </div>
          </template>
          <template #footer>
            <div />
          </template>
        </v-modal>
      </transition>
    </div>
  </div>
</template>

<script>
import BaseMixin from '@/components/Feature/BaseMixin.vue';
import Utility from '@/common/UtilityFunctions.js';
import RequestService from '@/common/requestService';

export default {
  name: 'TopBannerPowerOfAttorney',
  mixins: [BaseMixin],
  data() {
    return {
      vueModel: {},
      pending: false,
      showModalFail: false
    };
  },
  mounted() {
    $('body').addClass('power-of-attorney');
    const scrollTop = window.pageYOffset;
    if (scrollTop > 1) {
      $('.header-container').addClass('stuck');
    }

    RequestService.get(Utility.constants().API.topbanner_get)
      .then((response) => {
        this.vueModel = response.data;
      })
      .catch((error) => {
        Utility.logError(error, this);
      });
  },
  methods: {
    switchBackFromPOA() {
      const self = this;
      RequestService.post(Utility.constants().API.poa_impersonation)
        .then(() => {
          this.pending = false;
          window.onbeforeunload = function () {
            $('body').fadeOut();
            // window.scrollTo(0, 0);
            self.scrollToTop();
          };
          location.reload(true);
        })
        .catch(() => {
          this.pending = false;
          this.showModalFail = true;
        });
    },
    switchBackToList(url) {
      RequestService.post(Utility.constants().API.poa_impersonation_cancle)
        .then(() => {
          window.location.assign(`${url}`);
        })
        .catch(() => {
          this.showModalFail = true;
        });
    }
  }
};
</script>
